module.exports = __webpack_public_path__ + "img/OVASO.2280e205.png";